import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#FFD4B8',
} as const

export const resources = {
  loginBg: '/images/novelarc/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/novelarc/login/icon-facebook-logo.png',
  googleIcon: '/images/novelarc/login/icon-google-logo.png',
  appleIcon: '/images/novelarc/login/icon-apple-logo.png',
  emailIcon: '/images/novelarc/login/icon-email.png',
  emailCodeIcon: '/images/novelarc/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
